import * as React from 'react';

import {LatestOutreachListItem} from 'shells/email-latest-outreach-list/latest-outreach-list-item';
import type {Stat} from 'shells/email-latest-outreach-list/types';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {ErrorState} from 'shells/error-state/error-state';
import {Illustration} from 'shells/illustrations/illustration';
import {ListViewPaginated} from 'shells/list-view/list-view-paginated';

import {appHistory} from '../../../../history';

type OutreachType = 'EMAIL' | 'SMS';

type Props = {
    editions: any[];
    errorMessage: string | null | undefined;
    isLoading: boolean;
    hasNextPage: boolean;
    onFetchMoreRows: () => Promise<any>;
    convertEngagementStats: (engagementStats: any) => Stat[];
    outreachType: OutreachType;
};

export const AudienceOutreachList = (props: Props) => {
    const userFacingOutreachType = props.outreachType === 'EMAIL' ? 'email' : 'SMS';

    return (
        <ListViewPaginated
            specialStates={[
                {
                    shouldRender: () => Boolean(props.errorMessage),
                    component: <ErrorState errorMessage={props.errorMessage} />,
                },
                {
                    shouldRender: () => !props.isLoading && !props.editions.length,
                    component: (
                        <EmptyStateLarge
                            title='Nothing to see here'
                            subtitle={`You haven’t sent any ${userFacingOutreachType} outreach to this audience yet! Once you send some outreach, it will appear here.`}
                            icon={
                                <Illustration src='cactus-empty-state' width='120' height='120' />
                            }
                        />
                    ),
                },
            ]}
            isLoading={props.isLoading}
            renderRow={(edition) => {
                return (
                    <LatestOutreachListItem
                        key={edition.id}
                        edition={{
                            ...edition,
                            engagementStats: props.convertEngagementStats(edition.engagementStats),
                        }}
                        onView={() => {
                            appHistory.push(edition.htmlUrlPath);
                        }}
                        hideAudience={true}
                    />
                );
            }}
            collection={props.editions}
            onFetchMoreRows={props.onFetchMoreRows}
            hasNextPage={props.hasNextPage}
            itemSpacing={16}
            listPadding={16}
        />
    );
};
